import App from './App.vue';

export default {
  path: '/CDS_VF_ActivityBaseTotalList',
  name: 'CDS_VF_ActivityBaseTotalList',
  component: App,
  meta: {
    pageProperty: {
      title: '活動拠点集計',
      controller: 'CDS_CTR_ActivityBaseTotalList',
    },
  },
};
